/* ── WORK_TRACK — React auth screen mount ────────────────────
   Renders the React login/register screen into #authRoot inside
   #authView. Driven by the auth screen store so the vanilla
   modules (showAuth, setRegister, setBootOwner) keep working. */

import { useSyncExternalStore, type ReactElement } from 'react';
import { createRoot } from 'react-dom/client';
import { $ } from '@/core';
import { getAuthScreen, setAuthScreen, subscribeAuthScreen } from '@/auth-store';
import { SmokeyBackground, LoginForm } from '@/components/ui/login-form';

function AuthScreen(): ReactElement {
  const screen = useSyncExternalStore(subscribeAuthScreen, getAuthScreen);
  return (
    <main className="relative w-screen h-screen bg-gray-900 overflow-hidden">
      <div className="fixed inset-0">
        <SmokeyBackground className="absolute inset-0" />
      </div>
      <div className="relative z-10 flex items-center justify-center w-full h-full p-4">
        <LoginForm
          mode={screen.mode}
          bootOwner={screen.bootOwner}
          invite={screen.invite}
          resetToken={screen.resetToken}
          onModeChange={mode => setAuthScreen({ mode })}
        />
      </div>
    </main>
  );
}

export function mountAuth(): void {
  const rootEl = $('#authRoot');
  if (!rootEl) return;
  createRoot(rootEl).render(<AuthScreen />);
}